<template>
  <div v-if="$store.state.retIdentification">
    <md-card class="custom">
      <div class="md-subtitle">
        <span class="md-caption">{{ $t("identity.title") }}</span>
      </div>

      <div class="md-layout">
        <div
          class="md-layout-item label md-caption"
          :class="[
            $store.state.retIdentification.ResponsibleOfficer.content.length > 1
              ? ''
              : 'line',
            isMobile ? 'md-size-40' : 'md-size-30'
          ]"
        >
          {{ $t("identity.responsible-officer") }}:
        </div>
        <div
          class="md-layout-item bold label pl-30"
          :class="[
            $store.state.retIdentification.ResponsibleOfficer.content.length > 1
              ? ''
              : 'line',
            isMobile ? 'md-size-60' : 'md-size-70'
          ]"
        >
          <span
            v-if="
              $store.state.retIdentification.ResponsibleOfficer.content.length >
                1 &&
                $store.state.retIdentification.ResponsibleOfficer.content[1]
                  .JAXBElement.value.PersonName
            "
          >
            {{
              $store.state.retIdentification.ResponsibleOfficer.content[1]
                .JAXBElement.value.PersonName.FirstName[0].value
            }}
            {{
              $store.state.retIdentification.ResponsibleOfficer.content[1]
                .JAXBElement.value.PersonName.LastName[0].value
            }}</span
          >
          <span
            v-if="
              $store.state.retIdentification.ResponsibleOfficer.content.length >
                1 &&
                $store.state.retIdentification.ResponsibleOfficer.content[0]
                  .JAXBElement.value.PersonName
            "
          >
            {{
              $store.state.retIdentification.ResponsibleOfficer.content[0]
                .JAXBElement.value.PersonName.FirstName[0].value
            }}
            {{
              $store.state.retIdentification.ResponsibleOfficer.content[0]
                .JAXBElement.value.PersonName.LastName[0].value
            }}</span
          >
          <span
            v-if="
              $store.state.retIdentification.ResponsibleOfficer.content
                .length <= 1 &&
                $store.state.retIdentification.ResponsibleOfficer.content[0]
                  .JAXBElement.value.PersonName
            "
          >
            {{
              $store.state.retIdentification.ResponsibleOfficer.content[0]
                .JAXBElement.value.PersonName.FirstName[0].value
            }}
            {{
              $store.state.retIdentification.ResponsibleOfficer.content[0]
                .JAXBElement.value.PersonName.LastName[0].value
            }}
          </span>
        </div>
        <div
          v-if="
            $store.state.retIdentification.ResponsibleOfficer.content.length > 1
          "
          class="md-layout-item label md-caption line"
          :class="isMobile ? 'md-size-40' : 'md-size-30'"
        >
          {{ $t("identity.responsibility") }}:
        </div>
        <div
          v-if="
            $store.state.retIdentification.ResponsibleOfficer.content.length > 1
          "
          class="md-layout-item bold label line pl-30"
          :class="isMobile ? 'md-size-60' : 'md-size-70'"
        >
          <span
            v-if="
              $store.state.retIdentification.ResponsibleOfficer.content[0]
                .JAXBElement.value &&
                !$store.state.retIdentification.ResponsibleOfficer.content[0]
                  .JAXBElement.value.PersonName
            "
          >
            {{
              this.$store.state.retIdentification.ResponsibleOfficer.content[0]
                .JAXBElement.value
            }}
          </span>
          <span
            v-if="
              $store.state.retIdentification.ResponsibleOfficer.content[1]
                .JAXBElement.value &&
                !$store.state.retIdentification.ResponsibleOfficer.content[1]
                  .JAXBElement.value.PersonName
            "
          >
            {{
              this.$store.state.retIdentification.ResponsibleOfficer.content[1]
                .JAXBElement.value
            }}
          </span>
        </div>
      </div>
    </md-card>

    <div v-if="$store.state.retIdentification" class="margin-buttons">
      <md-button
        id="logout"
        @click="clicked(false)"
        class="md-raised md-accent"
        :disabled="confirmDisabled"
        :aria-disabled="confirmDisabled"
        ><md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >{{ $t("header.logout-button") }}</md-tooltip
        >
        {{ $t("identity.deny-button") }}
      </md-button>
      <md-button
        id="login"
        @click="clicked(true)"
        class="md-raised md-primary"
        :disabled="confirmDisabled"
        :aria-disabled="confirmDisabled"
        ><md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >{{ $t("identity.confirm-button") }}</md-tooltip
        >
        <span v-if="!$store.state.retIdentification.ElectionEvent.Description">
          {{ $t("identity.confirm-button") }}
        </span>
        <span v-if="$store.state.retIdentification.ElectionEvent.Description">
          {{ $t("identity.accept-button") }}
        </span>
      </md-button>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/Utils.js";

import { isMobile } from "mobile-device-detect";

export default {
  async mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();

    this.$i18n.locale = this.$store.getters.getKeycloakLanguage;
    //Se cambio lingua e ricarico la pagina, la lingua selezionata persiste
    if (
      sessionStorage.getItem("currentLanguageSelected") &&
      sessionStorage.getItem("currentLanguageSelected") !=
        this.$store.getters.getKeycloakLanguage
    ) {
      this.$i18n.locale = sessionStorage.getItem("currentLanguageSelected");
    }

    this.$router
      .push({
        params: { locale: this.$i18n.locale }
      })
      .catch(() => {});
  },
  data: function() {
    return {
      confirmjustopen: false,
      isMobile: false,
      confirmDisabled: false
    };
  },
  props: [],
  methods: {
    clicked(confirm) {
      if (confirm) {
        this.$store.commit("identityConfirmedSetter", true);
        /* this.$router.push("group").catch(() => {}); */
        this.$router.push({
          name: "group",
          params: { locale: this.$i18n.locale }
        });
      } else {
        this.$store.replaceState({});
        this.$keycloak.logoutFn();
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from;
      });
    }
  },
  components: {}
};
</script>

<style scoped>
.custom {
  margin: 5px;
  padding: 5px;
}

.label {
  text-align: left;
  margin: 0px;
  padding: 5px;
}

.md-card-content {
  padding: 30px !important;
  font-size: 18px;
  line-height: 22px;
}

.md-card {
  box-shadow: none !important;
  font-size: 18px !important;
  position: relative;
  z-index: 1;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: all;
  transition-property: color, background-color;
  will-change: color, background-color;
}

.md-card-header {
  text-align: left !important;
  text-transform: uppercase;
  border-left: 5px solid #387a8f;
  padding: 10px 20px;
  margin: 0 0 20px 5px;
}

.md-subtitle {
  text-align: left;
  text-transform: uppercase;
  font-size: 33px !important;
  border-left: 5px solid #387a8f;
  padding: 0 0 0 10px;
  margin: 20px 20px;
}

.custom .md-caption {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 18px;
  color: #000;
}

.margin-buttons {
  margin-top: 50px;
  margin-bottom: 50px;
}

.md-button.md-raised:not([disabled]) {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #940000 !important;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #387a8f !important;
}

.md-button {
  padding: 0 30px !important;
  font-weight: bold;
}

.line {
  border-bottom: 1px solid #dedede !important;
}

.label {
  padding: 10px 20px;
}

.profile {
  padding: 0;
}

@media screen and (max-width: 360px) {
  .md-button {
    padding: 0 !important;
  }

  .pl-30 {
    padding-left: 30px;
  }
}
</style>
